// Three-word / short-phrase checkmark bullets per use-case agent.
// Rendered under the "How we solve it" paragraph on /use-cases/:id.
// Keep each line 3–6 words, action-first, and grounded in what the agent
// actually does (not marketing fluff).

export const USE_CASE_BULLETS = {
    // ================ LISTEN & MEASURE ================
    csat: [
        "Reach out right after every interaction",
        "Capture stated score + sentiment score",
        "Cover ~100% of customers, not 5%",
    ],
    voc: [
        "Code 100% of conversations",
        "Tag themes and sentiment live",
        "Surface emerging issues early",
    ],
    fraud: [
        "Score every call against playbooks",
        "Catch voice-print anomalies live",
        "Route to the investigation queue",
    ],
    risk: [
        "Detect early risk signals",
        "Monitor complaint velocity",
        "Surface hardship and sentiment cues",
    ],

    // ================ SUPPORT & RESOLVE ================
    faq: [
        "Answer grounded in your KB",
        "Cite the source every time",
        "Say 'I don't know' safely",
    ],
    "it-support": [
        "Triage incidents in seconds",
        "Walk through known fixes",
        "Open and route tickets",
    ],
    dealer: [
        "Handle product and warranty queries",
        "Update order status 24/7",
        "Qualify leads in local languages",
    ],
    "field-service": [
        "Recall procedures on-site",
        "Look up parts instantly",
        "Warm handoff to an expert",
    ],
    care: [
        "Identify the customer fast",
        "Resolve routine intents autonomously",
        "Hand off warmly when needed",
    ],
    "pax-experience": [
        "Stitch PNR, ops and loyalty",
        "Answer at every travel stage",
        "Voice- and chat-native",
    ],
    "guest-experience": [
        "24/7 multi-lingual concierge",
        "Tie into PMS and F&B",
        "Local recommendations on demand",
    ],
    "patient-care": [
        "Schedule visits and refills",
        "Guide prep and follow-up",
        "HIPAA / DPDP-grade guardrails",
    ],
    "digital-banking": [
        "Handle accounts, cards, disputes",
        "Authenticate before every intent",
        "Full policy and audit trail",
    ],
    booking: [
        "Book, change, refund end-to-end",
        "Direct PNR / PMS / OMS access",
        "Policy-grounded responses",
    ],
    telemedicine: [
        "Triage symptoms before intake",
        "Verify coverage automatically",
        "Prep clinicians with structured notes",
    ],
    "wealth-mgmt": [
        "First-touch client servicing",
        "Statements, allocations, tax docs",
        "Warm handoff to the RM",
    ],
    "after-sales": [
        "Warranty and parts lookup",
        "Book service slots directly",
        "Route to the right dealer",
    ],

    // ================ REACH OUT ================
    outbound: [
        "Run campaigns in local languages",
        "Handle retries and callbacks",
        "Full campaign analytics",
    ],
    sms: [
        "Trigger on keyword events",
        "Call back within seconds",
        "Close the loop in one call",
    ],
    renewals: [
        "Reach out ahead of lapse",
        "Capture structured feedback",
        "Hand off qualified leads",
    ],
    "warranty-amc": [
        "Renew warranty and AMC at scale",
        "Voice-first, local languages",
        "Dealer routing when required",
    ],
    churn: [
        "Ingest churn scores from your model",
        "Call at-risk customers with offers",
        "Close the save loop",
    ],
    personalization: [
        "1:1 outreach across channels",
        "Trigger on live behaviour",
        "Voice, WhatsApp, SMS, email",
    ],

    // ================ OPERATE ================
    supply: [
        "Automate supplier status pings",
        "Escalate exceptions on the spot",
        "Grounded in TMS / ERP",
    ],
    "flight-ops": [
        "Coordinate crew during IROPS",
        "Structured station comms",
        "Confirmations and callbacks",
    ],
    cargo: [
        "Book cargo and quote rates",
        "AWB tracking on demand",
        "Handle exceptions on voice",
    ],
    fleet: [
        "Driver check-ins on voice",
        "ETA updates in real time",
        "Route exceptions to dispatch",
    ],
    "route-opt": [
        "Push live re-route suggestions",
        "Reach dispatchers and drivers",
        "Close the confirmation loop",
    ],
    "maint-predict": [
        "Act on predictive signals",
        "Schedule interventions automatically",
        "Coordinate parts and technicians",
    ],
    safety: [
        "Voice- or chat-based intake",
        "Classify and route incidents",
        "Feed the safety management system",
    ],
    operations: [
        "Run standard ops runbooks",
        "Handle status checks and escalations",
        "Grounded in your systems",
    ],
    "smart-rooms": [
        "In-room voice control",
        "Tie into PMS and housekeeping",
        "SLA-tracked requests",
    ],
    warehouse: [
        "Voice-first putaway and picking",
        "Handle exceptions hands-free",
        "Run cycle counts on the floor",
    ],
    "last-mile": [
        "Automate delivery-day comms",
        "Handle reschedules on voice",
        "Close the exception loop",
    ],
    "iot-tracking": [
        "Answer live 'where is it?' queries",
        "Voice and messaging access",
        "Grounded in the IoT platform",
    ],
    "network-opt": [
        "Coordinate NOC and field",
        "Keep customers informed",
        "End-to-end incident comms",
    ],
    "hospital-ops": [
        "Track bed status live",
        "Coordinate OT scheduling",
        "Voice-driven pharmacy comms",
    ],
    "pharma-logistics": [
        "Monitor cold-chain events",
        "Escalate exceptions in-shipment",
        "Regulatory paperwork prompts",
    ],
};
